export default "__VITE_ASSET__DN1a1CnB__"